<template>
	<div class="form-sidebar">
		<v-container class="grid-list-lg">
			<slot></slot>
		</v-container>
	</div>
</template>

<script>
export default {
	name: 'form-sidebar',
};
</script>

<style lang="scss" scoped>
.form-sidebar {
	padding: 10px 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/form-sidebar.vue